import React from 'react';
import { useTranslator } from '@front-activerse/common-components';
import { Button, Spinner } from 'reactstrap';

interface TrackerMealSaveAsUserMealButtonProps {
  isSaved: boolean;
  isSaving: boolean;
  onClick: () => void;
  savedIcon: string;
  addIcon: string;
}

const TrackerMealSaveAsUserMealButton: React.FC<TrackerMealSaveAsUserMealButtonProps> = ({
  isSaved,
  isSaving,
  onClick,
  savedIcon,
  addIcon,
}) => {
  const { t } = useTranslator();

  return (
    <Button
      color="link"
      size="sm"
      className={`save-your-meal-button ${isSaved ? 'saved' : ''} ${isSaving ? 'saving' : ''}`}
      onClick={onClick}
    >
      {isSaving ? (
        <>
          <Spinner size="sm" /> {t('yourMeal.saving')}
        </>
      ) : (
        <>
          <img src={isSaved ? savedIcon : addIcon} alt="" />
          {isSaved ? t('yourMeal.saved') : t('yourMeal.addButton')}
        </>
      )}
    </Button>
  );
};

export default TrackerMealSaveAsUserMealButton;
